import React, { Component } from 'react';
import './BottomFloat.less';

/**
 * BottomFloat 组件
 *
 * @class BottomFloat
 * @extends {React.Component<any>}
 */
class BottomFloat extends Component {
	public state: any = {
		isShowFloat: true,
	};
	/**
	 * 客户端调用获取数据
	 *
	 * @memberof BottomFloat
	 */
	public closeFloatClose(): void {
		this.setState({
			isShowFloat: false,
		});
	}
	/**
	 * 渲染页面
	 *
	 * @returns {*}
	 * @memberof BottomFloat
	 */
	public render(): any {
		return this.state.isShowFloat ? (
			<div className="bottom-float flex-center">
				<div className="center-box">
					<div className="middle">
						下载APP免费听1000+精品课程
						<br />
						和知识做朋友！
					</div>
					<div className="right">
						<img className="float-qrcode-img" src="https://img.qlchat.com/qlLive/activity/image/C1W3V3GI-TVLB-JOET-1604901796523-4ARIZLEG7K4W.png" alt="" />
						<div>扫码下载APP</div>
					</div>
				</div>
				<div className="btn-float-close p-icon-close" onClick={this.closeFloatClose.bind(this)}></div>
			</div>
		) : null;
	}
}

export default BottomFloat;
